import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SnackbarErrorIcon = forwardRef<SVGSVGElement, IconProps>(function SnackbarErrorIcon(
  { color = '#FF5C5C', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.8191 18.8907L20.819 18.8907L13.6292 23.0054C13.6288 23.0056 13.6285 23.0058 13.6282 23.006C12.6132 23.5803 11.3728 23.5787 10.373 23.0067C10.373 23.0067 10.373 23.0067 10.373 23.0067L3.18465 18.8928C3.18407 18.8925 3.18349 18.8922 3.18291 18.8918C2.17952 18.3066 1.56376 17.2428 1.56376 16.104V7.896C1.56376 6.74273 2.18148 5.68117 3.18091 5.10932L3.18131 5.10909L10.3587 0.994551C10.3591 0.994327 10.3595 0.994103 10.3599 0.993879C11.3748 0.419665 12.6151 0.421297 13.6149 0.993296C13.6149 0.993304 13.6149 0.993312 13.6149 0.993321L20.8032 5.10716C20.8038 5.10749 20.8044 5.10782 20.8049 5.10815C21.8083 5.69326 22.4252 6.74586 22.4362 7.89877V16.104C22.4362 17.2573 21.8185 18.3188 20.8191 18.8907Z"
        fill="url(#paint0_radial_390_22522)"
        stroke={color || 'currentColor'}
        strokeWidth="1.12752"
      />
      <path
        d="M11.092 6.9C11.092 6.408 11.5037 6 12.0001 6C12.4965 6 12.9082 6.408 12.9082 6.9V13.2C12.9082 13.692 12.4965 14.1 12.0001 14.1C11.5037 14.1 11.092 13.692 11.092 13.2V6.9ZM13.114 17.556C13.0535 17.7 12.9687 17.832 12.8598 17.952C12.6297 18.18 12.327 18.3 12.0001 18.3C11.8427 18.3 11.6853 18.264 11.54 18.204C11.3826 18.144 11.2615 18.06 11.1404 17.952C11.0315 17.832 10.9467 17.7 10.8741 17.556C10.8135 17.412 10.7893 17.256 10.7893 17.1C10.7893 16.788 10.9104 16.476 11.1404 16.248C11.2615 16.14 11.3826 16.056 11.54 15.996C11.988 15.804 12.5207 15.912 12.8598 16.248C12.9687 16.368 13.0535 16.488 13.114 16.644C13.1746 16.788 13.2109 16.944 13.2109 17.1C13.2109 17.256 13.1746 17.412 13.114 17.556Z"
        fill={color || 'currentColor'}
      />
      <defs>
        <radialGradient
          id="paint0_radial_390_22522"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(23 12) rotate(179.972) scale(39.875 223.999)"
        >
          <stop stopColor={color || 'currentColor'} stopOpacity="0.31" />
          <stop offset="0.516781" stopColor={color || 'currentColor'} stopOpacity="0.3" />
          <stop offset="1" stopColor="#1B1E24" />
        </radialGradient>
      </defs>
    </svg>
  );
});
